module.exports = __webpack_public_path__ + "static/media/car.59499b42.png";